export const BASIC_ROLE = 'basic'
export const COURSE_ONLY_ROLE = 'course only'
export const PREMIUM_ROLE = 'premium'
export const COACH_ROLE = 'coach'
export const ADMIN_ROLE = 'admin'

export const ALL_ROLES = [BASIC_ROLE, COURSE_ONLY_ROLE, PREMIUM_ROLE, COACH_ROLE, ADMIN_ROLE]
